'use es6';

import { Set as ImmutableSet } from 'immutable';
import * as DataTypes from 'reporting-data/constants/dataTypes';
import { getDataType } from 'reporting-data/public/get-data-type';

//The following types are deprecated or janky, so we prevent saving to discourage propagation
const SAVE_ACTION_DISALLOWED_DATA_TYPES = ImmutableSet([DataTypes.ANALYTICS_BEHAVIORAL_EVENTS, DataTypes.BLOG, DataTypes.BLOG_POSTS, DataTypes.DOCUMENTS, DataTypes.EXPERIMENTAL_REVENUE, DataTypes.KNOWLEDGE_ARTICLES, DataTypes.LEGACY_CAMPAIGNS, DataTypes.QUOTAS, DataTypes.SEQUENCES, DataTypes.TEMPLATES, DataTypes.UNIFIED_FEEDBACK_EMAIL, DataTypes.UNIFIED_FEEDBACK_WEB]);
export const hasSaveActionSupportedDataType = report => !SAVE_ACTION_DISALLOWED_DATA_TYPES.includes(getDataType(report));